import { TOGGLE_DEBUG_MODE } from '../actions/constants';

export default (previousState = false, { type }) => {
    if (type === TOGGLE_DEBUG_MODE) {
        return !previousState;
    }
    return previousState;
};
